import { useSplitEnabled } from '@buffer-mono/features'

import { COLLABORATION_NOTES_SPLIT } from '~publish/components/PostDialogs/PostDetailsContent/useCollaborationNotesPanel'
import { POST_GROUPS_UI_FLAG } from '~publish/components/PostDialogs/PostGroupDialog/postGroupsUiFlag'
import { CHANNEL_AGNOSTIC_DRAFT_FLAG } from '~publish/hooks/useChannelAgnosticDraftsEnabled'

/**
 * Gates every ContentItem Notes surface in Publish: the draft thread in the
 * composer and draft details, the archived draft Notes in a Post's panel, and
 * the Notes link. The server checks the same split; this only hides the UI.
 */
export const CONTENT_ITEM_NOTES_SPLIT = 'geid-content-item-collaboration-notes'

/**
 * ContentItem Notes build on Post Notes, channel-less drafts, and the
 * PostGroup UI, so they are on only while all four splits are.
 */
export function useContentItemNotesSplits(): {
  isReady: boolean
  isEnabled: boolean
} {
  const splits = [
    useSplitEnabled(CONTENT_ITEM_NOTES_SPLIT),
    useSplitEnabled(COLLABORATION_NOTES_SPLIT),
    useSplitEnabled(CHANNEL_AGNOSTIC_DRAFT_FLAG),
    useSplitEnabled(POST_GROUPS_UI_FLAG),
  ]
  const isReady = splits.every((split) => split.isReady)
  return {
    isReady,
    isEnabled: isReady && splits.every((split) => split.isEnabled),
  }
}

/** Off until every split resolves, so a Post thread looks as it does without. */
export function useContentItemNotesEnabled(): boolean {
  return useContentItemNotesSplits().isEnabled
}
